import { useEffect } from "react";
import { Waves } from "lucide-react";
import { BRL } from "./PixPayment";
import { Stepper } from "./ToursSection";

const enumerateDays = (from, to) => {
  const out = [];
  const d = new Date(`${from}T12:00:00Z`);
  const end = new Date(`${to}T12:00:00Z`);
  while (d <= end && out.length < 62) { out.push(d.toISOString().slice(0, 10)); d.setUTCDate(d.getUTCDate() + 1); }
  return out;
};
const fmtBR = (s) => s.split("-").reverse().join("/");

// Lets the guest attach jet ski tours to the stay booking.
export const TourExtras = ({ tours, checkin, checkout, extras, setExtras, comboPct = 0 }) => {
  const valid = tours.length > 0 && checkout > checkin;
  const days = valid ? enumerateDays(checkin, checkout) : [];

  useEffect(() => {
    if (!valid || !extras.some((x) => !days.includes(x.date))) return;
    setExtras(extras.map((x) => (days.includes(x.date) ? x : { ...x, date: days[1] || days[0] })));
  }, [checkin, checkout]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!valid) return null;
  const get = (id) => extras.find((x) => x.tour_id === id);
  const set = (id, patch) => setExtras(extras.map((x) => (x.tour_id === id ? { ...x, ...patch } : x)));
  const toggle = (t) => get(t.id)
    ? setExtras(extras.filter((x) => x.tour_id !== t.id))
    : setExtras([...extras, { tour_id: t.id, date: days[1] || days[0], time: t.time_slots[0], qty: 1 }]);

  return (
    <div className="mb-4 rounded-2xl border border-cyan-200 bg-cyan-50/60 p-4" data-testid="tour-extras">
      <p className="text-[11px] font-bold text-cyan-800 uppercase mb-1 flex items-center gap-1.5"><Waves className="w-3.5 h-3.5" /> Adicione um passeio de jet ski</p>
      {comboPct > 0 && <p className="text-xs text-emerald-700 font-semibold mb-3" data-testid="combo-badge">Combo casa + jet ski: {comboPct}% de desconto no passeio</p>}
      {!comboPct && <div className="mb-2" />}
      <div className="space-y-3">
        {tours.map((t) => {
          const x = get(t.id);
          return (
            <div key={t.id} className="bg-white rounded-xl border border-cyan-100 p-3">
              <label className="flex items-start gap-2.5 cursor-pointer">
                <input type="checkbox" checked={Boolean(x)} onChange={() => toggle(t)} className="mt-1 w-4 h-4 accent-[#0A66C2]" data-testid={`extra-toggle-${t.id}`} />
                <span className="flex-1 min-w-0">
                  <span className="block text-sm font-bold text-slate-800">{t.title}</span>
                  <span className="block text-xs text-slate-500">{BRL(t.price)} {t.price_unit} · {t.location}</span>
                </span>
              </label>
              {x && (
                <div className="grid grid-cols-3 gap-2 mt-3 items-center">
                  <select value={x.date} onChange={(e) => set(t.id, { date: e.target.value })} className="col-span-3 sm:col-span-1 p-2 rounded-lg border border-slate-200 text-xs" data-testid={`extra-date-${t.id}`}>
                    {days.map((d) => <option key={d} value={d}>{fmtBR(d)}</option>)}
                  </select>
                  <select value={x.time} onChange={(e) => set(t.id, { time: e.target.value })} className="col-span-2 sm:col-span-1 p-2 rounded-lg border border-slate-200 text-xs" data-testid={`extra-time-${t.id}`}>
                    {t.time_slots.map((h) => <option key={h} value={h}>{h}</option>)}
                  </select>
                  <Stepper value={x.qty} onChange={(q) => set(t.id, { qty: q })} max={t.units || 1} testId={`extra-qty-${t.id}`} />
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export const extrasTotals = (tours, extras, comboPct = 0) =>
  extras.reduce((acc, x) => {
    const t = tours.find((y) => y.id === x.tour_id);
    if (!t) return acc;
    const gross = Number(t.price) * x.qty;
    const combo = Math.round(gross * comboPct) / 100;
    const sub = gross - combo;
    return { total: acc.total + sub, combo: acc.combo + combo, deposit: acc.deposit + (sub * Number(t.deposit_percent ?? 50)) / 100 };
  }, { total: 0, combo: 0, deposit: 0 });
